module.exports = __webpack_public_path__ + "static/media/bgDetails.ae8b718e.png";